<div class="component text-center reset-password">
  <div class="reset-password-overlay"></div>
  <div class="card">
    <p>Please enter your email:</p>
    <form #ef="ngForm" [formGroup]="emailForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <input type="email" id="email" class="form-control" formControlName="email" [disabled]="ef.submitted">
      </div>
      <button [disabled]="ef.submitted" type="submit" class="btn reset-password-button">
        Reset Password
      </button>
    </form>
    <div class="alert alert-success" *ngIf="ef.submitted && isSuccessful">
      We have sent you an email with instructions
    </div>
    <div class="alert alert-warning" *ngIf="ef.submitted && !isSuccessful && errorMessage">
      {{ errorMessage }}
    </div>
  </div>
</div>
